export default {
    "language": "Язык",
    "title": "Главная",
}
